import gsap from "gsap"
import { logTool } from "@jsUtils"

const log = logTool()

let Styles

const animateIn = styles => {
  log("animateIn")

  Styles = styles

  // dynamic bubbles WRAPPER
  const SVG = child => (child ? `.${Styles.bubbles} ${child}` : `.${Styles.bubbles}`)

  const start = {
    opacity: 0.8,
    scale: 0.05 // oddly scale of 0 alters the layout in Firefox
  }
  const stop = {
    opacity: 1,
    scale: 1,
    y: "-=200"
  }

  // so GSAP never gets .false as a target
  if (Styles.bubbles) {
    log("running...")
    gsap
      .timeline({
        defaults: {
          duration: 1.5,
          opacity: 1,
          ease: "power4.out",
          transformOrigin: "50% 50%"
        }
      })
      // set bubbles to be seen
      .set(SVG(), {
        opacity: 1
      })
      // We need "extra canvas" on the SVG to work with so there's
      // nothing being cropped:
      // - set bubble svg to be seen; we pull it (y) above the top
      //   boundary so the items moving have "space"
      //   and give a little nudge to the x axis so there is also
      //   horizontal space,
      // - then we realign the content inside the viewBox
      .set(SVG("svg"), {
        scale: 1.1, // scale boundary up
        opacity: 1,
        y: "-=100",
        x: "-=50" // create an offset on the side to avoid cropping
      })
      .set(SVG("svg g"), {
        scale: 0.9 // scale content down
      })
      .set(SVG("svg path"), {
        opacity: 0,
        y: "+=300",
        // "+=100" --> actual desired (y) position, so, when we run,
        // we go to "-=200" (see above start/stop values)
        x: "+=50" // persist the offset on the site
      })
      .add("start")
      .fromTo(SVG("path.outside.top"), start, stop, "start")
      .fromTo(SVG("path.mid.top"), start, stop, "start+=.3")
      .fromTo(SVG("path.centerPoint"), start, stop, "start+=.5")
      .fromTo(SVG("path.mid.bottom"), start, stop, "start+=.7")
      .fromTo(SVG("path.outside.bottom"), start, stop, "start+=.9")
  }
}

export { animateIn }
export default animateIn
